import { useMemo } from 'react';
import { TFunction } from 'i18next';

import useFlexibleColumnsTable from '../../../../hooks/useFlexibleColumnsTable';
import { LOCAL_STORAGE_KEYS } from '../../../../shared/settingsNames';
import { INotificationTemplateTranslation } from '../../../../types/interfaces/notification-admin';
import getNotificationTemplateDetailTranslationsTableColumns, {
  getNotificationTemplateDetailTranslationsDefaultSettings,
} from './notificationTemplateDetailTranslationsTableColumns';
import { getNotificationTemplateDetailTranslationsCellReducers } from './getNotificationTemplateDetailTranslationsCellReducers';

export function useNotificationTemplateDetailTranslationsTable(
  translations: INotificationTemplateTranslation[],
  t: TFunction,
  classes: Record<string, string>,
  canMutate: boolean,
  canDelete: boolean,
  langLabel: (languageId: string) => string,
  onEdit: (row: INotificationTemplateTranslation) => void,
  onDelete: (row: INotificationTemplateTranslation) => void,
) {
  const includeActions = canMutate || canDelete;

  const cellReducers = useMemo(
    () =>
      getNotificationTemplateDetailTranslationsCellReducers(
        t,
        classes,
        { canMutate, canDelete },
        langLabel,
        onEdit,
        onDelete,
      ),
    [t, classes, canMutate, canDelete, langLabel, onEdit, onDelete],
  );

  const { order: defaultOrder, orderBy } =
    getNotificationTemplateDetailTranslationsDefaultSettings(t, includeActions);

  const useTableData = useFlexibleColumnsTable(
    translations,
    LOCAL_STORAGE_KEYS.NOTIFICATION_TEMPLATE_DETAIL_TRANSLATIONS_TABLE_SETTINGS,
    getNotificationTemplateDetailTranslationsTableColumns(t, includeActions),
    orderBy,
    defaultOrder,
  );

  return { ...useTableData, cellReducers };
}
